"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.514 2.57 5.37 12.592l.922.382L10.436 2.95l-.922-.381ZM5.477 9.248H2.365A1.37 1.37 0 0 1 .998 7.88a1.37 1.37 0 0 1 1.367-1.367h4.39v-.999h-4.39A2.368 2.368 0 0 0 0 7.88a2.368 2.368 0 0 0 2.365 2.366h3.112v-.998Zm5.045-3.734h3.112A2.369 2.369 0 0 1 16 7.881a2.369 2.369 0 0 1-2.366 2.365H9.245v-.998h4.389a1.37 1.37 0 0 0 1.368-1.367 1.37 1.37 0 0 0-1.368-1.369h-3.112v-.998Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.488 4.265 8.349 19.11l.866.358 6.139-14.844-.866-.359ZM.948 12.033a2.402 2.402 0 0 1 2.398-2.399h6.742v-.937H3.346A3.34 3.34 0 0 0 .01 12.033a3.34 3.34 0 0 0 3.336 3.337h4.78v-.938h-4.78a2.402 2.402 0 0 1-2.399-2.399Zm14.926-3.336h4.78a3.34 3.34 0 0 1 3.336 3.336 3.34 3.34 0 0 1-3.336 3.337h-6.742v-.938h6.742a2.402 2.402 0 0 0 2.399-2.399 2.402 2.402 0 0 0-2.4-2.399h-4.779v-.937Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m19.204 5.437-8.205 19.844 1.386.573L20.59 6.01l-1.386-.573ZM1.526 15.866a3.04 3.04 0 0 1 3.037-3.037h8.902v-1.5H4.563a4.542 4.542 0 0 0-4.537 4.537 4.542 4.542 0 0 0 4.537 4.537h6.311v-1.5h-6.31a3.04 3.04 0 0 1-3.038-3.037Zm19.58-4.537h6.311a4.542 4.542 0 0 1 4.537 4.537 4.542 4.542 0 0 1-4.537 4.537h-8.902v-1.5h8.902a3.04 3.04 0 0 0 3.037-3.037 3.04 3.04 0 0 0-3.037-3.037h-6.312v-1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M28.976 8.53 16.697 38.22l1.732.716 12.28-29.689-1.732-.717ZM1.893 24.067a4.804 4.804 0 0 1 4.798-4.798h13.484v-1.875H6.692a6.68 6.68 0 0 0-6.673 6.673 6.68 6.68 0 0 0 6.673 6.672h9.56v-1.875h-9.56a4.803 4.803 0 0 1-4.798-4.797Zm29.854-6.674h9.56a6.68 6.68 0 0 1 6.672 6.673 6.68 6.68 0 0 1-6.672 6.674H27.823v-1.875h13.485a4.804 4.804 0 0 0 4.797-4.799 4.803 4.803 0 0 0-4.797-4.797h-9.56v-1.875Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m38.634 11.374-16.37 39.585 2.31.956 16.37-39.585-2.31-.956ZM2.526 32.089a6.405 6.405 0 0 1 6.397-6.397h17.979v-2.5H8.922c-4.905 0-8.896 3.99-8.896 8.897 0 4.906 3.99 8.897 8.897 8.897H21.67v-2.5H8.923a6.405 6.405 0 0 1-6.397-6.397ZM42.33 23.19h12.746c4.906 0 8.897 3.991 8.897 8.897 0 4.907-3.991 8.898-8.897 8.898h-17.98v-2.5h17.98a6.405 6.405 0 0 0 6.397-6.398 6.405 6.405 0 0 0-6.397-6.397H42.33v-2.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconBrokenLink = function IconBrokenLink(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Broken Link' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "BrokenLink"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconBrokenLink.sizes = [16, 24, 32, 48, 64];
IconBrokenLink.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconBrokenLink;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/BrokenLink.js
// module id = 2323
// module chunks = 0